import React from 'react'
import { HorizontalStack } from '@ztechapps/webui.util'
import { useTableContext } from '../Context'

export const RowCountTableStats = ({ label }: { label: string }) => {
  const context = useTableContext()

  const { count } = context?.listResult?.pageInfo || {}
  const listCount = context?.listResult?.list?.length || 0

  return (
    <HorizontalStack gap={1}>
      <div>Showing {listCount} of</div>
      <div className="fw-bold">{count}</div>
      <div>{label}.</div>
    </HorizontalStack>
  )
}
